<script>
import moment from 'moment'
  
const { VUE_APP_API_HOST } = process.env 

  export default {
    data() {
      return {
        lastNotif: {
            text: null,
            date: null,
            id: null
        }
      }
    },
    methods: {

        notify(options, context=null) {
            if(!this.lastNotif.text || options.id == 'repeat' || (this.lastNotif.text 
                              && this.lastNotif.text == options.text
                              && (moment(this.lastNotif.date).isBefore(moment())
                                    || (this.lastNotif.id != options.id || !this.lastNotif.id)))) {
                this.$vs.notify({
                    title: options.title || 'Erreur',
                    text: this.$t(options.text),
                    color: options.color || 'danger',
                    time: options.time || 10000
                })
                this.lastNotif.text = options.text
                this.lastNotif.date = moment().add(30, 'seconds')
                this.lastNotif.id = options && options.id ? options.id : null

                //log notif
                if(context)
                  this.notifySlack(options, context)      
                // this.$http
                //   .post(`${VUE_APP_API_HOST}/log/slack`, {
                //       email: JSON.parse(localStorage.user).email,
                //       title: options.title || 'Erreur',
                //       text: this.$t(options.text),
                //       context
                //     }, {
                //     headers: {
                //       Authorization: `Bearer ${localStorage.getItem('token')}`
                //     }
                //   })
                //   .then(res => res, err => err)

            }
        },

        notifySlack(options, context=null) {
          //log notif      
          this.$http
            .post(`${VUE_APP_API_HOST}/log/slack`, {
                email: JSON.parse(localStorage.user).email,
                title: options.title || 'Erreur',
                text: this.$t(options.text),
                context
              }, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
              }
            })
            .then(res => res, err => err)
        },

        getFrontVersion() {
          return this.$http
                    .get(`${VUE_APP_API_HOST}/tools/front-version`, {
                      headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                      }
                    })
                    .then(res => res, err => err)
        }, 
        
    }
  }
</script>
